import { render } from "./ReviewDocumentReferences.vue?vue&type=template&id=3858078f&ts=true"
import script from "./ReviewDocumentReferences.ts?vue&type=script&lang=ts&external"
export * from "./ReviewDocumentReferences.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__